import { withChartLayout } from 'components/common';
import Wounds from 'components/features/chart/wounds/Wounds';

const WoundsPage = withChartLayout('Wounds')(Wounds);
export default WoundsPage;
